module.exports = __webpack_public_path__ + "img/fold.a324a30f.png";